







import Vue from "vue";
import MCUMovieList from "./components/MCUMovieList.vue";
import MCUSelector from "./components/MCUSelector.vue";

import MovieSeries from "./lib/MovieSeries";
import MovieRepository from "./lib/MovieRepository";
import { Movie, OrderingMap } from './lib/types';
import { NUMBER_OF_MCU_MOVIES, DEFAULT_MCU_ORDER } from './lib/constants';

import * as movies from "./assets/data/movies.json";
import * as importedOrderings from "./assets/data/orderings.json";

const orderings: OrderingMap = Object.assign(importedOrderings, {
    release: [...Array(NUMBER_OF_MCU_MOVIES)].map((_, index) => index + 1)
});

const mcuMovies = new MovieSeries("mcu", movies, orderings, new MovieRepository(localStorage));

export default {
    data: function() {
        return {
            selectedOrder: DEFAULT_MCU_ORDER,
            movieModel: mcuMovies
        }
    },
    methods: {
        updateOrderingSelection: function(variable: string) {
            this.selectedOrder = variable;
        }
    },
    components: {
        "mcu-selector": MCUSelector,
        "mcu-movie-list": MCUMovieList
    }
};
